import { ReactElement } from 'react';
import classNames from 'classnames';

import { SearchMenuFields } from '../../../types';
import { SearchProvider } from '../providers';
import { SearchMenu } from './SearchMenu';

interface SearchProps {
  fields: SearchMenuFields;
  isDropdown?: boolean;
}

export const Search = (searchProps: SearchProps): ReactElement => {
  return (
    <div
      className={classNames(
        'relative z-20 w-full origin-top-right bg-success',
        searchProps.isDropdown ? '' : 'min-h-24'
      )}
    >
      <SearchProvider>
        <SearchMenu menuItem={searchProps.fields} isMenuOpened={searchProps.isDropdown} />
      </SearchProvider>
    </div>
  );
};
